import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-planejamento',
  templateUrl: './planejamento.component.html',
  styleUrls: ['./planejamento.component.scss'],
})
export class PlanejamentoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
